import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Select,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import useAuthStore from "../../../services/AuthStore";

export default function Teachers() {
  const { getTeachers, getSubjects } = useAuthStore();
  const [teachers, setTeachers] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [currentTeacher, setCurrentTeacher] = useState({
    user_id: null,
    lastname: "",
    name: "",
    surname: "",
    email: "",
    phone: "",
    subjects_ids: [],
  });
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      let newteachers = await getTeachers();
      console.log(newteachers.teachers);
      if (newteachers.teachers.length > 0) {
        let newdata = newteachers?.teachers?.map((item, index) => ({
          ...item,
          id: index,
        }));
        setTeachers(newdata);
      } else {
        setTeachers([]);
      }
    };
    fetchData();
    getSubjects().then(data => setSubjects(data));
  }, []);

  const handleOpenDialog = (
    teacher = {
      user_id: null,
      lastname: "",
      name: "",
      surname: "",
      email: "",
      phone: "",
      subjects_ids: [],
    },
  ) => {
    setCurrentTeacher(teacher);
    setIsEditing(!!teacher.user_id);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setCurrentTeacher({
      user_id: null,
      lastname: "",
      name: "",
      surname: "",
      email: "",
      phone: "",
      subjects_ids: [],
    });
  };

  const handleSaveTeacher = () => {
    if (isEditing) {
      setTeachers(prev =>
        prev.map(t =>
          t.user_id === currentTeacher.user_id ? currentTeacher : t,
        ),
      );
    } else {
      setTeachers(prev => [
        ...prev,
        { ...currentTeacher, user_id: prev.length + 1 },
      ]);
    }
    handleCloseDialog();
  };

  const columns = [
    { field: "user_id", headerName: "Номер", width: 90 },
    { field: "lastname", headerName: "Фамилия", width: 120 },
    { field: "name", headerName: "Имя", width: 120 },
    { field: "surname", headerName: "Отчество", width: 120 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phone", headerName: "Телефон", width: 150 },
    {
      field: "subjects",
      headerName: "Предметы",
      width: 250,
      renderCell: params => {
        if (params.row.subjects_ids) {
          return params.row.subjects_ids
            ?.map(id => subjects.find(sub => sub.id === id)?.name || "Unknown")
            .join(", ");
        } else {
          return "";
        }
      },
    },
    {
      field: "actions",
      headerName: "Действия",
      width: 200,
      renderCell: params => (
        <Box>
          <Button onClick={() => handleOpenDialog(params.row)}>Edit</Button>
          <Button
            color="error"
            onClick={() => handleDeleteTeacher(params.row.user_id)}>
            Delete
          </Button>
        </Box>
      ),
    },
  ];

  const handleDeleteTeacher = id => {
    setTeachers(prev => prev.filter(t => t.user_id !== id));
  };

  return (
    <Box>
      <Typography variant="h6" style={{ marginBottom: 16 }}>
        Учителя
      </Typography>
      <Button onClick={() => handleOpenDialog()}>Добавить Учителя</Button>
      <Box sx={{ height: 400, width: "100%", maxWidth: "md" }}>
        <DataGrid rows={teachers} columns={columns} pageSize={5} />
      </Box>
      <Dialog open={dialogOpen} onClose={handleCloseDialog}>
        <DialogTitle>
          {isEditing ? "Редактировать Учителя" : "Добавить Учителя"}
        </DialogTitle>
        <DialogContent>
          <TextField
            label="Имя"
            fullWidth
            value={currentTeacher.name}
            onChange={e =>
              setCurrentTeacher({ ...currentTeacher, name: e.target.value })
            }
          />
          <TextField
            label="Фамилия"
            fullWidth
            value={currentTeacher.lastname}
            onChange={e =>
              setCurrentTeacher({ ...currentTeacher, lastname: e.target.value })
            }
          />
          <TextField
            label="Email"
            fullWidth
            value={currentTeacher.email}
            onChange={e =>
              setCurrentTeacher({ ...currentTeacher, email: e.target.value })
            }
          />
          <TextField
            label="Телефон"
            fullWidth
            value={currentTeacher.phone}
            onChange={e =>
              setCurrentTeacher({ ...currentTeacher, phone: e.target.value })
            }
          />
          <Typography>Предметы</Typography>
          <Select
            multiple
            value={currentTeacher.subjects_ids}
            onChange={e =>
              setCurrentTeacher({
                ...currentTeacher,
                subjects_ids: e.target.value,
              })
            }>
            {subjects.map(sub => (
              <MenuItem key={sub.id} value={sub.id}>
                {sub.name}
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button onClick={handleSaveTeacher}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
